// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/beaker.js';

import { paths } from '../generated/beaker';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('beaker', Original, paths);
